const PayoutStatusEnum = Object.assign({
  NEW: 'new',
  UPLOADED: 'uploaded',
  IMPORTED: 'imported',
});

Object.freeze(PayoutStatusEnum);

export default PayoutStatusEnum;



// WEBPACK FOOTER //
// ./src/enum/baader/PayoutStatus.js